import React from "react"
import BaseModal from "./BaseModal"

const AlertModal = props => {
  return <BaseModal {...props} className="modal-centered" />
}

export default AlertModal
